/**
 * Generate a unique view transition name for an accommodation card/detail.
 * Use the same name on both the search card and detail page for shared element transition.
 */
export function getAccommodationTransitionName(id: number | string): string {
  return `accommodation-${id}`
}
